// #region imports

// --- Angular
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

// --- HS Code
import { environment } from '../../../../environments/environment';

// #endregion

@Component({
  selector: 'hs-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivateComponent implements OnInit {
  private _isInitialized: boolean;

  @Input() emailAddress: string;
  @Input() token: string;
  @Input() error: string;

  @Output() activated = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    (<any>window).Intercom("boot", {
      app_id: "m7san35s",
      name: "There", 
      email: this.getRandomEmail(),   //"no-reply@heartstyles.com",
      created_at: new Date()
    });
  }

  getRandomEmail() {
    let result = '';
    for (var i = 0; i < 5; i++) {
      result += String.fromCharCode(Math.floor(Math.random() * 25) + 97);
    }
    return result + '@heartstyles.com';
  }

  onClick(e: any): void {
    this.activated.emit(this.token);
  }
}
